<template>
  <div>
    <div class="row">
      <div
        :class="getClassList(el)"
        v-for="(el, index) of listFieldsVal"
        :key="'field' + index"
      >
        <template
          v-if="
            isItemShow(modelData, el, listAllRelatedFields || listFieldsVal, isAnnonymousAccess) &&
            !el.isHidden
          "
        >
          <template v-if="el.type === FORM_TYPE.ARRAY_OBJECT">
            <template v-if="!isNaN(modelData[el.size])">
              <template v-for="childRowIndex in Number(modelData[el.size])">
                <FormGroupRowLayout
                  :key="'childRowIndex-' + childRowIndex"
                  :listFields="el.items"
                  :modelData="modelData[el.model][childRowIndex - 1]"
                  :submitClicked="isHightlightError(index)"
                  @input="handleInputField(el, index)"
                />
              </template>
            </template>
          </template>
          <template v-else-if="el.type === FORM_TYPE.HEADER_SLOT">
            <div>
              <h3 class="builder-setting-header-slot"></h3>
            </div>
          </template>
          <template v-else-if="el.type === FORM_TYPE.HEADER">
            <h3 :key="'header' + index" class="mt-4 d-flex">
              {{ getFieldProperty(el, "label") }}
            </h3>
            <hr
              v-if="!el.isFirst"
              :key="'header-separate' + index"
              style="margin: 0"
            />
            <div
              :key="'admin-description' + index"
              class="admin-description"
              v-if="el.adminDescription"
            >
              <div v-html="el.adminDescription"></div>
            </div>
            <div
              :key="'description' + index"
              class="description"
              v-if="el.description"
            >
              <div v-html="el.description"></div>
            </div>
          </template>
          <template v-else-if="el.type === FORM_TYPE.SUB_HEADER">
            <div :key="'sub_header' + index" classList="">
              <h4 style="margin-top: 1em">
                {{ getFieldProperty(el, "label") }}
              </h4>
              <div class="admin-description" v-if="el.adminDescription">
                <div v-html="el.adminDescription"></div>
              </div>
              <div v-if="el.description" class="description">
                <div v-html="el.description"></div>
              </div>
            </div>
          </template>
          <template v-else-if="el.type === FORM_TYPE.HTML">
            <div :key="'html' + index" v-html="el.html"></div>
          </template>
          <template
            v-else-if="
              [
                FORM_TYPE.SLOT,
                FORM_TYPE.SECTION,
                FORM_TYPE.BOOKING_SECTION,
                FORM_TYPE.EVALUATION,
                FORM_TYPE.FILE_WITH_INFO,
                FORM_TYPE.PAYMENT,
                FORM_TYPE.RETURNING_APPLICANT_BTN,
              ].includes(el.type)
            "
          >
            <slot :name="el.label"></slot>
          </template>
          <template v-else-if="el.type === FORM_TYPE.SIGN_DOCUMENT">
            <slot :name="el.documentTemplateId + '-' + el.label"></slot>
          </template>
          <template v-else-if="el.type === FORM_TYPE.STRIPE_SUBSCRIPTION_SELECTION">
            <slot :name="'stripe-subscription-selection' + el.label"></slot>
          </template>
          <template v-else-if="el.type === FORM_TYPE.CHECKBOX_CONDITION">
            <slot :name="'checkbox-condition' + el.label"></slot>
          </template>
          <template v-else-if="el.type === FORM_TYPE.SEPARATOR">
            <hr :key="'seprator' + index" style="margin-bottom: 0" />
          </template>
          <template v-else>
            <!-- Text area with share model option (result is saved in an array) -->
            <TextAreaWithLabel
              v-if="
                el.type === FORM_TYPE.TEXTAREA &&
                el.isShareModel &&
                Array.isArray(modelData[el.model])
              "
              :key="'textarea-share-model' + index"
              classList=""
              :label="getFieldLabel(el)"
              :rows="el.rows"
              :maxLength="getMaxLength(el)"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :placeholder="getFieldProperty(el, 'placeholder')"
              :defaultValue="el.defaultValue"
              v-model="modelData[el.model][el.shareModelIndex]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :isCounter="el.isCounter"
              :builderField="el"
            />
            <TextAreaWithLabel
              v-else-if="el.type === FORM_TYPE.TEXTAREA"
              :key="'textarea' + index"
              classList=""
              :label="getFieldLabel(el)"
              :rows="el.rows"
              :maxLength="getMaxLength(el)"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :placeholder="getFieldProperty(el, 'placeholder')"
              :defaultValue="el.defaultValue"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :isCounter="el.isCounter"
              :builderField="el"
            />
            <PasswordWithLabel
              v-else-if="el.type === FORM_TYPE.PASSWORD"
              :key="'password' + index"
              classList=""
              :label="getFieldLabel(el)"
              :confirmLabel="getFieldProperty(el, 'confirmLabel')"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <CheckboxGroup
              v-else-if="el.type === FORM_TYPE.CHECKBOX"
              :key="'checkbox' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :optionList="getOptionList(el)"
              :mapOptionListByLang="getMapOptionListByLanguage(el)"
              :mapDisplayedOptions="el.mapDisplayedOptions"
              :numberOfColumn="el.numberOfColumn"
              :hasOther="el.hasOther"
              :isHtml="el.isHtml"
              :exclusiveOptions="el.exclusiveOptions"
              :hasCheckAll="el.hasCheckAll"
              :markAllAsChecked="el.markAllAsChecked"
              :textboxOption="el.textboxOption"
              :defaultValue="el.defaultValue"
              :messageDialogs="el.messageDialogs"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
              :tagData="tagData"
              :buttonGroups="el.buttonGroups"
              @reloadData="$emit('reloadData')"
              @clickBtn="
                $emit('clickMultiSelectBtn', {
                  btnId: $event,
                  model: el.model,
                  el: el,
                })
              "
            />
            <CheckboxItem
              v-else-if="el.type === FORM_TYPE.CHECKBOX_ITEM"
              :key="'checkbox-item' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model"
              :option="el.option"
              :messageDialogs="el.messageDialogs"
              :buttonGroups="el.buttonGroups"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :defaultValue="el.defaultValue"
              :builderField="el"
            />
            <!-- Checkbox icon group -->
            <CheckboxIconGroup
              v-else-if="el.type === FORM_TYPE.CHECKBOX_ICON"
              :key="'checkbox-icon' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :optionList="getOptionList(el)"
              :mapOptionListByLang="getMapOptionListByLanguage(el)"
              :defaultValue="el.defaultValue"
              :iconList="el.iconList"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <!-- Radio Group with share model option (selected result is saved in an array) -->
            <RadioGroup
              v-else-if="
                el.type === FORM_TYPE.RADIO &&
                el.isShareModel &&
                Array.isArray(modelData[el.model])
              "
              :key="'radio' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model + '-shareIndex-' + el.shareModelIndex"
              :description="getFieldProperty(el, 'description')"
              :isHtml="el.isHtml"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :optionList="getOptionList(el)"
              :mapOptionListByLang="getMapOptionListByLanguage(el)"
              :hasOther="el.hasOther"
              :defaultValue="el.defaultValue"
              :numberOfColumn="el.numberOfColumn"
              :isBooleanModel="isBooleanRadioModel(el.model)"
              v-model="modelData[el.model][el.shareModelIndex]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <RadioGroup
              v-else-if="el.type === FORM_TYPE.RADIO"
              :key="'radio' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model"
              :description="getFieldProperty(el, 'description')"
              :isHtml="el.isHtml"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :bottomDescription="el.bottomDescription"
              :optionList="getOptionList(el)"
              :mapOptionListByLang="getMapOptionListByLanguage(el)"
              :hasOther="el.hasOther"
              :defaultValue="el.defaultValue"
              :numberOfColumn="el.numberOfColumn"
              :isBooleanModel="isBooleanRadioModel(el.model)"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
              :buttonGroups="el.buttonGroups"
              @clickBtn="
                $emit('clickMultiSelectBtn', {
                  btnId: $event,
                  model: el.model,
                  el: el,
                })
              "
            />
            <!-- Rating -->
            <StarRating
              v-else-if="el.type === FORM_TYPE.RATING"
              :key="'rating' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :hasOther="el.hasOther"
              :defaultValue="el.defaultValue"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <!-- Radio Icon Group with share model option (selected result is saved in an array) -->
            <RadioIconGroup
              v-else-if="
                el.type === FORM_TYPE.RADIO_ICON &&
                el.isShareModel &&
                Array.isArray(modelData[el.model])
              "
              :key="'radio' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :optionList="getOptionList(el)"
              :mapOptionListByLang="getMapOptionListByLanguage(el)"
              :defaultValue="el.defaultValue"
              :isBooleanModel="isBooleanRadioModel(el.model)"
              :iconList="el.iconList"
              v-model="modelData[el.model][el.shareModelIndex]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <RadioIconGroup
              v-else-if="el.type === FORM_TYPE.RADIO_ICON"
              :key="'radio' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :bottomDescription="el.bottomDescription"
              :optionList="getOptionList(el)"
              :mapOptionListByLang="getMapOptionListByLanguage(el)"
              :defaultValue="el.defaultValue"
              :iconList="el.iconList"
              :isBooleanModel="isBooleanRadioModel(el.model)"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <DropdownWithLabel
              v-else-if="
                el.type === FORM_TYPE.DROPDOWN &&
                el.isShareModel &&
                Array.isArray(modelData[el.model])
              "
              :key="'dropdown' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :optionList="getOptionList(el)"
              :mapOptionListByLang="getMapOptionListByLanguage(el)"
              :defaultValue="el.defaultValue"
              v-model="modelData[el.model][el.shareModelIndex]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <DropdownWithLabel
              v-else-if="el.type === FORM_TYPE.DROPDOWN"
              :key="'dropdown' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :optionList="getOptionList(el)"
              :mapOptionListByLang="getMapOptionListByLanguage(el)"
              :defaultValue="el.defaultValue"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <DatePickerWithLabel
              v-else-if="el.type === FORM_TYPE.DATEPICKER"
              :key="'datepicker' + index"
              classList=""
              :label="getFieldLabel(el)"
              :initialView="el.initialView"
              :allowPastDate="el.allowPastDate"
              :dateFormat="el.dateFormat"
              :appendToBody="isAppendToBody(el)"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :minDate="el.minDate"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <YearPickerWithLabel
              v-else-if="el.type === FORM_TYPE.YEAR_PICKER"
              :key="'datepicker' + index"
              classList=""
              :label="getFieldLabel(el)"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <MultiDatePicker
              v-else-if="el.type === FORM_TYPE.MULTI_DATEPICKER"
              :key="'multi-datepicker' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.name"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <TimePickerWithLabel
              v-else-if="el.type === FORM_TYPE.TIME_PICKER"
              :key="'timepicker' + index"
              classList=""
              :label="getFieldLabel(el)"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :minutesInterval="el.minutesInterval"
              :is24HoursFormat="is24HoursFormat(el)"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
              :defaultValue="defaultTime(el)"
            />
            <MonthPickerWithLabel
              v-else-if="el.type === FORM_TYPE.MONTH_PICKER"
              :key="'monthpicker' + index"
              classList=""
              :label="getFieldLabel(el)"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :initialView="el.initialView"
              :after="modelData[el.after]"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <DateTimePickerWithLabel
              v-else-if="el.type === FORM_TYPE.DATETIME_PICKER"
              :key="'datetimepicker' + index"
              classList=""
              :label="getFieldLabel(el)"
              :initialView="el.initialView"
              :allowPastDate="el.allowPastDate"
              :minutesInterval="el.minutesInterval"
              :is24HoursFormat="is24HoursFormat(el)"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <div
              v-else-if="el.type === FORM_TYPE.DAY_HOURS_SELECTOR"
              :key="'day-hours-selector' + index"
              classList=""
            >
              <!-- Use textbox to input time -->
              <DayHoursInput
                classList=""
                :label="getFieldLabel(el)"
                :description="getFieldProperty(el, 'description')"
                :adminDescription="getFieldProperty(el, 'adminDescription')"
                :listDays="getFieldProperty(el, 'listDays')"
                :hasTimeOff="el.hasTimeOff"
                :hasNote="el.hasNote"
                :customLabels="getFieldProperty(el, 'customLabels')"
                :minutesInterval="el.minutesInterval"
                :is24HoursFormat="is24HoursFormat(el)"
                v-model="modelData[el.model]"
                :submitClicked="isHightlightError(index)"
                @input="handleInputField(el, index)"
                :isRequired="el.isRequired"
                :builderField="el"
                :useTimePicker="el.useTimePicker"
              />
            </div>

            <SalaryRange
              v-else-if="el.type === FORM_TYPE.SALARY_RANGE"
              :key="'salary-range' + index"
              :label="getFieldLabel(el)"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :hidePeriod="el.hidePeriod"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <MultiSelectWithLabel
              v-else-if="el.type === FORM_TYPE.MULTI_SELECT"
              :key="'multi-select' + index"
              classList=""
              :label="getFieldLabel(el)"
              :optionList="
                getOptionList(el) ||
                modelData[el.optionListModel] ||
                getOptionListByConditions(el)
              "
              :optionKey="modelData[el.optionKey]"
              :mapOptionListByLang="getMapOptionListByLanguage(el)"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :isMulti="el.isMulti"
              :isArrayModel="el.isArrayModel"
              :searchable="el.searchable"
              :closeOnSelect="!el.openOnSelect"
              :defaultValue="el.defaultValue"
              :placeholder="getFieldProperty(el, 'placeholder')"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @userInput="handleUserSelect($event, el, index)"
              @select="handleSelect($event, el.model)"
              :isRequired="el.isRequired"
              :builderField="el"
              :hasOther="el.hasOther"
              :optionLabel="el.optionLabel"
              :optionModel="el.optionModel"
              :hasClearButton="el.hasClearButton"
              :buttonGroups="el.buttonGroups"
              :additionalSelectedInfoFunc="el.additionalSelectedInfoFunc"
              :infoLinkId="el.infoLinkId"
              @changed="handleChange"
              :optionListTransformFunc="el.optionListTransformFunc"
              :formObject="modelData"
              @clickBtn="
                $emit('clickMultiSelectBtn', {
                  btnId: $event,
                  model: el.model,
                  el: el,
                })
              "
            />
            <HtmlSelection
              v-else-if="el.type === FORM_TYPE.HTML_SELECTION"
              :key="'html-selection' + index"
              classList=""
              :label="getFieldLabel(el)"
              :optionList="getOptionList(el)"
              :mapOptionListByLang="getMapOptionListByLanguage(el)"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :isMulti="el.isMulti"
              :htmlList="el.htmlList"
              :numberOfColumn="el.numberOfColumn"
              :messageDialogs="el.messageDialogs"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
              :scrollToNextItem="el.scrollToNextItem"
            />
            <FileWithLabel
              v-else-if="el.type === FORM_TYPE.FILE && submitInfo"
              :key="'file' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :remark="el.remark"
              :maxSize="el.maxSize"
              :fileType="el.fileType"
              :initialUrl="el.initialUrl"
              v-model="modelData[el.model]"
              :blankFileUrl="el.blankFileUrl"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
              :submitInfo="submitInfo"
            />
            <FileUpload
              v-else-if="el.type === FORM_TYPE.FILE"
              :key="'file' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :remark="el.remark"
              :maxSize="el.maxSize"
              :fileType="el.fileType"
              :initialUrl="el.initialUrl"
              v-model="modelData[el.model]"
              :blankFileUrl="el.blankFileUrl"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
              :hasAccessControlBtn="hasFileAccessControlBtn"
              @accessControl="$emit('fileAccessControl', el)"
            />
            <CroppedFileUpload
              v-else-if="el.type === FORM_TYPE.CROPABLE_FILE"
              :key="'cropped-file' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :remark="el.remark"
              :maxSize="el.maxSize"
              :fileType="el.fileType"
              :initialUrl="el.initialUrl"
              v-model="modelData[el.model]"
              :blankFileUrl="el.blankFileUrl"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
              :submitInfo="submitInfo"
            />
            <RatingGroup
              v-else-if="el.type === FORM_TYPE.RATING_GROUP"
              :key="'rating-group' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :itemList="el.itemList"
              :gradeList="el.gradeList"
              :numberOfColumn="el.numberOfColumn"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <RadioTable
              v-else-if="el.type === FORM_TYPE.RADIO_TABLE"
              :key="'radio-table' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :optionList="getOptionList(el)"
              :mapOptionListByLang="getMapOptionListByLanguage(el)"
              :itemList="el.itemList"
              :headerList="el.headerList"
              :numberOfColumn="el.numberOfColumn"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <CheckboxTable
              v-else-if="el.type === FORM_TYPE.CHECKBOX_TABLE"
              :key="'checkbox-table' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :optionList="getOptionList(el)"
              :mapOptionListByLang="getMapOptionListByLanguage(el)"
              :itemList="el.itemList"
              :headerList="el.headerList"
              :hasNote="el.hasNote"
              :noteHeader="el.noteHeader"
              :numberOfColumn="el.numberOfColumn"
              :customizableItemList="el.customizableItemList"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <LanguageInput
              v-else-if="el.type === FORM_TYPE.LANGUAGE_INPUT"
              :key="'language input' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :optionList="getOptionList(el)"
              :mapOptionListByLang="getMapOptionListByLanguage(el)"
              :numberOfColumn="el.numberOfColumn"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <ProductSelection
              v-else-if="el.type === FORM_TYPE.PRODUCT_SELECTION"
              :key="'product selection' + index"
              classList=""
              :label="getFieldLabel(el)"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :productList="el.productList"
              :descriptionList="el.descriptionList"
              :priceList="el.priceList"
              :iconList="el.iconList"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <CreditPackageSelection
              v-else-if="[FORM_TYPE.CREDIT_PACKAGE_SELECTION, FORM_TYPE.MONTHLY_CREDIT_PACKAGE_SELECTION].includes(el.type)"
              :key="'credit package selection' + index"
              classList=""
              :label="getFieldLabel(el)"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :htmlList="el.htmlList"
              :creditNumberList="el.creditNumberList"
              :isMonthly="el.isMonthlyCreditSubscription"
              :isCashCredit="el.isCashCredit"
              :priceList="el.priceList"
              :idList="el.idList"
              :userTypeList="el.userTypeList"
              :nameList="el.nameList"
              v-model="modelData.credit_package"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :builderField="el"
            />
            <TextEditor
              v-else-if="el.type === FORM_TYPE.TEXT_EDITOR"
              :key="'code-editor' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model"
              :description="getFieldProperty(el, 'description')"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              :defaultValue="el.defaultValue"
              :listTagFields="el.listTagFields"
              :isMail="el.isMail"
              v-model="modelData[el.model]"
              :submitClicked="isHightlightError(index)"
              @input="handleInputField(el, index)"
              :isRequired="el.isRequired"
              :openTag="el.openTag"
              :closeTag="el.closeTag"
              :builderField="el"
            />
            <LogItem
              v-else-if="el.type === FORM_TYPE.LOGGING"
              :key="'logging' + index"
              classList=""
              :label="getFieldLabel(el)"
              :name="el.model"
              :description="getFieldProperty(el, 'description')"
              :logItem="el.logItem"
              :adminDescription="getFieldProperty(el, 'adminDescription')"
              v-model="modelData[el.model]"
            />
            <ComputedExpression
              v-else-if="el.type === FORM_TYPE.EXPRESSION"
              :key="'expression' + index"
              classList=""
              :expression="el.expression"
              :applicationData="modelData"
            />
            <ListDateTimesPickerInput
              v-else-if="el.type === FORM_TYPE.LIST_DATE_TIMES_PICKER"
              :key="'list-date-times-picker' + index"
              classList=""
              :label="getFieldLabel(el)"
              :allowPastDate="el.allowPastDate"
              :appendToBody="el.appendToBody"
              :minutesInterval="el.minutesInterval"
              :additionalLabel="el.additionalLabel"
              :additionalModel="el.additionalModel"
              :maxDate="el.maxDate"
              :secondaryLabel="getFieldProperty(el, 'description')"
              :objectData="modelData"
              :minDuration="el.minDuration"
              v-model="modelData[el.model]"
            />
            <PlacementJobSelection
              v-else-if="el.type === FORM_TYPE.PLACEMENT_JOB_SELECTION"
              classList=""
              :key="'placement-job-selection' + index"
              :label="getFieldLabel(el)"
              :buttonText="getFieldProperty(el, 'buttonText')"
              :secondaryLabel="getFieldProperty(el, 'description')"
              v-model="modelData.selected_placement_jobs"
            />
            <EmailAttachment
              v-else-if="el.type === FORM_TYPE.LIST_FILES"
              classList=""
              :key="'list-files' + index"
              :label="getFieldLabel(el)"
              :description="getFieldProperty(el, 'description')"
              :name="getFieldProperty(el, 'name')"
              v-model="modelData[el.model]"
            />
            <VideoInput
              v-else-if="el.type === FORM_TYPE.VIDEO"
              classList=""
              :key="'video-input' + index"
              :label="getFieldLabel(el)"
              :description="getFieldProperty(el, 'description')"
              :userID="el.userID"
              :initialVideoUrl="modelData[el.videoUrlModel || 'video_url']"
              :type="el.videoType || 'Candidate Job Application'"
              :showResultMessage="false"
              v-model="modelData[el.model]"
            />
            <div
              v-else-if="el.type === FORM_TYPE.LABEL"
              classList=""
              :key="'label' + index"
            >
              <label>{{ getFieldProperty(el, "label") }}</label>
              <div class="form-type-label" v-if="el.model">
                {{ el.model }}
              </div>
            </div>
            <div
              v-else-if="el.type === FORM_TYPE.LIST_ITEMS"
              classList=""
              :key="'label' + index"
            >
              <label>{{ getFieldProperty(el, "label") }}</label>
              <ul>
                <li
                  class="list-item"
                  v-for="item in convertStringToArray(el.itemList)"
                  :key="item"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
            <!-- List textboxes, the labels are specified by labelModel -->
            <div
              v-else-if="el.type === FORM_TYPE.LIST_TEXTBOX"
              :key="'list-textbox' + index"
              class="list-textbox-container"
            >
              <div
                v-if="
                  modelData[el.labelModel] &&
                  modelData[el.labelModel].length > 0
                "
              >
                <label>{{ getFieldProperty(el, "label") }}</label>
                <div class="row" style="margin-top: -8px">
                  <TextBoxWithLabel
                    classList="col-lg-6"
                    v-for="(label, subIndex) of modelData[el.labelModel]"
                    :key="'textbox-' + index + '-' + subIndex"
                    :label="label"
                    :submitClicked="isHightlightError(index)"
                    @input="handleInputField(el, index)"
                    :isRequired="true"
                    v-model="modelData[el.model][subIndex]"
                  />
                </div>
              </div>
            </div>
            <div
              v-else-if="el.type === FORM_TYPE.LIST_TEXTAREA"
              :key="'list-textarea' + index"
              class="list-textarea-container"
            >
              <div
                v-if="
                  modelData[el.referModel] &&
                  modelData[el.referModel].length > 0
                "
              >
                <label>{{ getFieldProperty(el, "label") }}</label>
                <div class="row" style="margin-top: -8px">
                  <TextAreaWithLabel
                    classList="col-lg-6"
                    v-for="(model, subIndex) of modelData[el.referModel]"
                    :key="'text-area-' + index + '-' + subIndex"
                    :label="el.transformLabel(model)"
                    :submitClicked="isHightlightError(index)"
                    @input="handleInputField(el, index)"
                    :placeholder="el.placeholder"
                    :isRequired="true"
                    v-model="modelData[el.model][model]"
                  />
                </div>
              </div>
            </div>
            <!-- Color picker -->
            <div
              v-else-if="el.type === FORM_TYPE.COLOR_PICKER"
              class="color-picker-container"
              classList=""
              :key="'color-picker' + index"
            >
              <div class="color-picker-label">
                <label>
                  {{ getFieldProperty(el, "label") }}
                  <span v-if="el.isRequired !== false" class="asterisk-mark"
                    >*</span
                  >
                </label>
              </div>
              <div class="color-picker pl-2">
                <v-swatches
                  v-model="modelData[el.model]"
                  :swatches="getColorPickerOptions()"
                  show-fallback
                  fallback-input-type="color"
                  popover-x="left"
                ></v-swatches>
              </div>
            </div>
            <div
              v-else-if="el.type === FORM_TYPE.SIGNATURE_FIELD"
              :key="'signature' + index"
              classList=""
            >
              <SignatureField
                classList=""
                :label="getFieldLabel(el)"
                :maxLength="getMaxLength(el)"
                :description="getFieldProperty(el, 'description')"
                :adminDescription="getFieldProperty(el, 'adminDescription')"
                :defaultValue="el.defaultValue"
                :placeholder="getFieldProperty(el, 'placeholder')"
                v-model="modelData[el.model]"
                :submitClicked="isHightlightError(index)"
                @input="handleInputField(el, index)"
                :isRequired="el.isRequired"
                :builderField="el"
              />
            </div>
            <!-- Textbox with share model option (selected result is saved in an array) -->
            <div
              v-else-if="
                ![
                  FORM_TYPE.SECTION,
                  FORM_TYPE.BOOKING_SECTION,
                  FORM_TYPE.FILE_WITH_INFO,
                  FORM_TYPE.PAYMENT,
                  FORM_TYPE.DATA,
                  FORM_TYPE.RETURNING_APPLICANT_BTN,
                ].includes(el.type) &&
                el.isShareModel &&
                Array.isArray(modelData[el.model])
              "
              :key="'textbox' + index"
              classList=""
            >
              <TextBoxWithLabel
                classList=""
                :label="getFieldLabel(el)"
                :maxLength="getMaxLength(el)"
                :description="getFieldProperty(el, 'description')"
                :adminDescription="getFieldProperty(el, 'adminDescription')"
                :defaultValue="el.defaultValue"
                :type="getInputType(el)"
                :placeholder="getFieldProperty(el, 'placeholder')"
                :validation="el.validation"
                v-model="modelData[el.model][el.shareModelIndex]"
                :submitClicked="isHightlightError(index)"
                @input="handleInputField(el, index)"
                :isRequired="el.isRequired"
                :builderField="el"
              />
            </div>
            <div
              v-else-if="
                ![
                  FORM_TYPE.SECTION,
                  FORM_TYPE.BOOKING_SECTION,
                  FORM_TYPE.FILE_WITH_INFO,
                  FORM_TYPE.DATA,
                  FORM_TYPE.RETURNING_APPLICANT_BTN,
                ].includes(el.type)
              "
              :key="'textbox' + index"
              classList=""
            >
              <TextFieldWithConfirmation
                v-if="el.hasConfirmField"
                :class="{
                  'email-textbox': ['email', 'email2'].includes(el.model),
                }"
                classList=""
                :label="getFieldLabel(el)"
                :confirmLabel="getFieldProperty(el, 'confirmLabel')"
                :maxLength="getMaxLength(el)"
                :description="getFieldProperty(el, 'description')"
                :adminDescription="getFieldProperty(el, 'adminDescription')"
                :defaultValue="el.defaultValue"
                :type="getInputType(el)"
                :placeholder="getFieldProperty(el, 'placeholder')"
                :validation="el.validation"
                v-model="modelData[el.model]"
                :submitClicked="isHightlightError(index)"
                @input="handleInputField(el, index)"
                :isRequired="el.isRequired"
                :builderField="el"
                @blur="$emit('blur', el.model)"
              />
              <TextBoxWithLabel
                v-else
                :class="{
                  'email-textbox': ['email', 'email2'].includes(el.model),
                }"
                classList=""
                :label="getFieldLabel(el)"
                :maxLength="getMaxLength(el)"
                :description="getFieldProperty(el, 'description')"
                :adminDescription="getFieldProperty(el, 'adminDescription')"
                :defaultValue="el.defaultValue"
                :type="getInputType(el)"
                :placeholder="
                  getFieldProperty(el, 'placeholder') ||
                  getDefaultPlaceHolder(el)
                "
                :validation="el.validation"
                v-model="modelData[el.model]"
                :submitClicked="isHightlightError(index)"
                @input="handleInputField(el, index)"
                :isRequired="el.isRequired"
                :builderField="el"
                :buttonGroups="el.buttonGroups"
                :formData="modelData"
                @clickBtn="
                  $emit('clickTextboxBtn', { btnId: $event, model: el.model })
                "
                @blur="$emit('blur', el.model)"
              />
              <slot v-if="el.slotTag" :name="el.slotTag" />
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
/* This component is used to show for a list of form (textbox, radio button, checkbox, datepicker ...)
Each element of form group will be layout by each row, from top to bottom
*/
import {
  FORM_TYPE,
  TEXTBOX_INPUT_TYPE,
} from "../../constants/custom-define-type";
import TextBoxWithLabel from "./form-elements/TextBoxWithLabel";
import TextAreaWithLabel from "./form-elements/TextAreaWithLabel";
import DatePickerWithLabel from "./form-elements/DatePickerWithLabel";
import YearPickerWithLabel from "./form-elements/YearPickerWithLabel.vue";
import TimePickerWithLabel from "./form-elements/TimePickerWithLabel";
import MonthPickerWithLabel from "./form-elements/MonthPickerWithLabel";
import RadioGroup from "./form-elements/RadioGroup";
import RadioIconGroup from "./form-elements/RadioIconGroup";
import CheckboxIconGroup from "./form-elements/CheckboxIconGroup.vue";
import DropdownWithLabel from "./form-elements/DropdownWithLabel";
import CheckboxGroup from "./form-elements/CheckboxGroup";
import MultiSelectWithLabel from "./form-elements/MultiSelectWithLabel";
import FileWithLabel from "./form-elements/FileWithLabel";
import FileUpload from "./form-elements/FileUpload";
import { DATA_MODEL_MAX_LENGTH } from "../../constants/data-model-length";
import { MODEL_USER_PHONE_FIELD } from "../../constants/model-by-types";
import CheckboxItem from "./form-elements/CheckboxItem.vue";
import { mapGetters, mapActions } from "vuex";
import axios from "axios";

export default {
  name: "FormGroupRowLayout",
  components: {
    TextBoxWithLabel,
    TextAreaWithLabel,
    DatePickerWithLabel,
    YearPickerWithLabel,
    TimePickerWithLabel,
    MonthPickerWithLabel,
    DateTimePickerWithLabel: () =>
      import("./form-elements/DateTimePickerWithLabel.vue"),
    RadioGroup,
    RadioIconGroup,
    CheckboxIconGroup,
    DropdownWithLabel,
    CheckboxGroup,
    DayHoursInput: () => import("./complex-input-elements/DayHoursInput"),
    SalaryRange: () => import("./complex-input-elements/SalaryRange"),
    MultiSelectWithLabel,
    FileWithLabel,
    FileUpload,
    RatingGroup: () => import("./complex-input-elements/RatingGroup"),
    RadioTable: () => import("./complex-input-elements/RadioTable"),
    CheckboxTable: () => import("./complex-input-elements/CheckboxTable"),
    LanguageInput: () => import("./complex-input-elements/LanguageInput"),
    TextEditor: () => import("./complex-input-elements/TextEditor"),
    MultiDatePicker: () => import("./form-elements/MultiDatePicker"),
    ProductSelection: () =>
      import("./complex-input-elements/ProductSelection.vue"),
    StarRating: () => import("./complex-input-elements/StarRating.vue"),
    VSwatches: () => import("vue-swatches"),
    HtmlSelection: () => import("./complex-input-elements/HtmlSelection"),
    ComputedExpression: () =>
      import("./complex-input-elements/ComputedExpression.vue"),
    CheckboxItem,
    LogItem: () => import("./complex-input-elements/LogItem.vue"),
    PasswordWithLabel: () => import("./form-elements/PasswordWithLabel"),
    CroppedFileUpload: () => import("./form-elements/CroppedFileUpload"),
    TextFieldWithConfirmation: () =>
      import("./form-elements/TextFieldWithConfirmation"),
    CreditPackageSelection: () =>
      import("./complex-input-elements/CreditPackageSelection.vue"),
    PlacementJobSelection: () =>
      import("./complex-input-elements/PlacementJobSelection.vue"),
    EmailAttachment: () => import("./EmailAttachment.vue"),
    VideoInput: () => import("./videos/VideoInput.vue"),
    SignatureField: () => import("./form-elements/SignatureField"),
    ListDateTimesPickerInput: () =>
      import("./combined-list-input/ListDateTimesPickerInput"),
  },
  props: {
    listFields: {
      type: Array,
      default: () => [],
    },
    modelData: Object,
    tagData: Object,
    submitClicked: {
      type: Boolean,
      default: false,
    },
    // In some case, admin access the form as annonymous view
    isAnnonymousAccess: {
      type: Boolean,
      default: false,
    },
    // Info if submit file to server after upload
    submitInfo: Object,
    isDragEnabled: {
      type: Boolean,
      default: false,
    },
    hasFileAccessControlBtn: Boolean,
    listAllRelatedFields: Array
  },
  data: function () {
    return {
      FORM_TYPE: FORM_TYPE,
      highestTouchIndex: 0, // Last focus, filled fields
      listFieldsVal: [],
      isShowSectionBuilderUpSertDialog: false,
      selectedBuilderId: null,
    };
  },
  watch: {
    listFields: {
      handler(val) {
        this.listFieldsVal = val || [];
        if (val) {
          val.forEach((field) => {
            if (field.model === "timezone") {
              field.optionList = Intl.supportedValuesOf("timeZone");
            }
            if (field.predefinedOptionKey && this.agencyPredefinedOptionList) {
              const optionItem = this.agencyPredefinedOptionList.find(
                (item) => item.key === field.predefinedOptionKey
              );
              if (optionItem) {
                field.optionList = optionItem.value;
              }
            }
          });
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters([
      "phoneDefaultFormat",
      "agencyLanguages",
      "agencyPredefinedOptionList",
      "isAgent",
    ]),
    language() {
      return this.$store.getters.language;
    },
  },
  methods: {
    ...mapActions(["reloadProfileBuilderList"]),
    handleSelect(val, model) {
      // Use in import user dialog
      this.$emit("changed", [[model, val]]);
    },
    handleUserSelect(modelVal, el, index) {
      this.$nextTick(() => {
        this.handleInputField(el, index);
      });
    },
    handleChange(modelVal) {
      const selectedFieldsData = Object.entries(this.modelData).filter(
        (item) => item[1] == modelVal
      );
      this.$emit("changed", selectedFieldsData);
    },
    getClassList(el) {
      const bootstrapClassList = this.getBootstrapClassList(el);
      return bootstrapClassList;
    },
    getBootstrapClassList(el) {
      if (
        !el ||
        [
          FORM_TYPE.ARRAY_OBJECT,
          FORM_TYPE.SLOT,
          FORM_TYPE.SECTION,
          FORM_TYPE.BOOKING_SECTION,
          FORM_TYPE.HEADER,
          FORM_TYPE.SEPARATOR,
          FORM_TYPE.SIGN_DOCUMENT,
          FORM_TYPE.EVALUATION,
          FORM_TYPE.PAYMENT,
          FORM_TYPE.HTML,
          FORM_TYPE.DATA,
          FORM_TYPE.RETURNING_APPLICANT_BTN,
        ].includes(el.type)
      ) {
        return "col-lg-12";
      }
      if (Array.isArray(el)) {
        return "col-lg-12";
      }
      const itemPerRow = el.itemPerRow;
      if (itemPerRow === 0) {
        return "col";
      }
      let result = "";
      if (itemPerRow == null || itemPerRow === 1) {
        result = "col-lg-12";
      } else {
        result = "col-lg-" + String(12 / itemPerRow);
      }
      if (el.type === FORM_TYPE.TIME_PICKER) {
        result = `${result} col-6`;
      }
      return result;
    },
    getMaxLength(el) {
      if (el.maxLength) {
        return el.maxLength;
      }
      if (Object.keys(DATA_MODEL_MAX_LENGTH).includes(el.model)) {
        return DATA_MODEL_MAX_LENGTH[el.model];
      }
      if (el.model && el.model.includes("selector")) {
        return 255;
      }
      return null;
    },
    getFieldLabel(item) {
      let label = this.getFieldProperty(item, "label");
      if (item.transformLabel) {
        return item.transformLabel(this.modelData, label);
      }
      return label;
    },
    getFieldProperty(item, key) {
      if (item == null) {
        return "";
      }
      if (this.language) {
        if (item[key + "_lang_" + this.language]) {
          return item[key + "_lang_" + this.language];
        }
      }
      if (key === "label" && !item[key] && item.keyLangLabel) {
        if (item.keyLangLabelParams) {
          return this.getLabelByKeys(
            item.keyLangLabel,
            ...item.keyLangLabelParams
          );
        } else {
          return this.getLabelByKeys(item.keyLangLabel);
        }
      }
      return item[key];
    },
    getMapOptionListByLanguage(item) {
      if (!item.optionList) {
        return {};
      }
      let listOptionsByLangs;
      if (item.keyLangOptions) {
        listOptionsByLangs = this.getLabelByKeys(item.keyLangOptions);
      } else {
        if (!this.language) {
          return {};
        }
        if (!item["optionList_lang_" + this.language]) {
          return {};
        }
        listOptionsByLangs = this.convertStringToArray(
          item["optionList_lang_" + this.language]
        );
      }
      const listOptions = this.convertStringToArray(item.optionList);
      const result = {};
      for (let index = 0; index < listOptions.length; index++) {
        result[listOptions[index]] = listOptionsByLangs[index];
      }
      return result;
    },
    getInputType(el) {
      if (el.isIntegerField) {
        return TEXTBOX_INPUT_TYPE.POSITIVE_INTEGER;
      }
      if (el.isFloatField) {
        return TEXTBOX_INPUT_TYPE.DOUBLE;
      }
      return el.inputType;
    },
    is24HoursFormat(el) {
      if (el.others) {
        return el.others.includes("is 24 Hour Format") ? true : false;
      }
      return false;
    },
    isAppendToBody(el) {
      if (el.others) {
        return el.others.includes("Show Datepicker Over Modal") ? true : false;
      }
      return false;
    },
    defaultTime(el) {
      if (
        el.others &&
        el.others.includes("Default Time") &&
        el.defaultTime &&
        el.defaultTime["hh"] &&
        el.defaultTime["mm"]
      ) {
        return el.defaultTime;
      }
      return null;
    },
    getOptionListByConditions(el) {
      const optionList = el.optionListAll;
      if (!optionList) {
        return [];
      }
      let result = [];
      for (const option of optionList) {
        if (
          !option.show_condition ||
          !option.show_condition.showIf ||
          !option.show_condition.showIfValue
        ) {
          result.push(option);
          continue;
        }
        const value = this.modelData[option.show_condition.showIf];
        if (value == null) {
          continue;
        }
        if (option.show_condition.showIfValue.includes(value)) {
          result.push(option);
        }
      }
      return result;
    },
    getDefaultPlaceHolder(el) {
      if (MODEL_USER_PHONE_FIELD.includes(el.model)) {
        return this.phoneDefaultFormat;
      }
    },
    getOptionList(el) {
      let optionList = el.optionList;
      if (!optionList) {
        if (el.model === "language") {
          return this.agencyLanguages;
        }
      }
      if (this.language) {
        if (el["optionList_lang_" + this.language]) {
          return el["optionList_lang_" + this.language];
        }
      }
      return optionList;
    },
    isHightlightError(index) {
      if (this.submitClicked) {
        return true;
      }
      if (index < this.highestTouchIndex) {
        return true;
      }
      return false;
    },
    handleInputField(el, index) {
      if (this.modelData && this.modelData[el.model]) {
        if (index > this.highestTouchIndex) {
          this.highestTouchIndex = index;
        }
      }
      if (el.isShareModel && Array.isArray(this.modelData[el.model])) {
        this.$emit("reloadData");
      } else if (
        [
          FORM_TYPE.RADIO,
          FORM_TYPE.CHECKBOX,
          FORM_TYPE.DROPDOWN,
          FORM_TYPE.MULTI_SELECT,
        ].includes(el.type)
      ) {
        this.$emit("updatedSelection", el.model);
      } else if (el.type === FORM_TYPE.DATEPICKER) {
        this.$emit("updatedDate");
      } else if (el.type === FORM_TYPE.TIME_PICKER) {
        this.$emit("updatedTime");
      }
    },
  },
};
</script>

<style scoped>
.header-section {
  margin-bottom: 0;
}

.form-type-label {
  padding-top: 0.375rem;
}

.list-item {
  color: var(--coredarkcolor);
}

.list-textbox-container {
  width: 100%;
}

.color-picker-container {
  display: flex;
  align-items: center;
  margin-top: 15px;
}

.color-picker-label > label {
  margin-top: 0;
  margin-bottom: 0;
}

.color-picker-label {
  flex-basis: 33em;
}

.col-lg-3:empty {
  display: none;
}
.col-lg-4:empty {
  display: none;
}
.col-lg-6:empty {
  display: none;
}
.col-lg-12:empty {
  display: none;
}
.col-lg-2:empty {
  display: none;
}

.col-lg:empty {
  display: none;
}

.col:empty {
  display: none;
}

.builder-setting-header-slot {
  position: absolute;
  right: 15px;
  top: 0;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/common/FormGroupRowLayout.vue